import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
      cacheRoutes: "",
      headerName:'首页',
      userInfo:{},//用户信息
      homePageIsHidden:true,//完全没有权限时全隐藏
      onePageHidden:false,//没有首页权限是隐藏首页内容
      isTopBadge:false,//顶部系统消息提示
  },
  mutations: {
      addCacheRoute(state, routeName) {
          state.cacheRoutes = routeName
      },
      updateUserInfo(state,data){
          state.userInfo = data;
      },
      setHeaderName(state,data){
          state.headerName = data;
      },
      setHomePageIsHidden(state,data){
          state.homePageIsHidden = data;
      },
      setOnePageHidden(state,data){
          state.onePageHidden = data;
      },
      modifyIsTopBadge(state,data){
          state.isTopBadge = data
      },
  },
  actions: {
  },
  modules: {
  }
})
